import * as React from 'react';
import { IOperationResultNoValue } from '../../models/Api';

export type ErrorType = IOperationResultNoValue | string[] | Error;

export interface IErrorMessagesContext {
	pushError(error: ErrorType): void;
}

export const ErrorMessagesContext = React.createContext<IErrorMessagesContext>(null);

export const useErrorMessagesContext = () => {
	const context = React.useContext(ErrorMessagesContext);
	if (!context) {
		throw new Error('This component requires the use of "ErrorMessagesContext".');
	}

	return context;
};
